import {ReviewSection} from './review-section.types'
import {SupportSection} from './support-section.types'
import {KnowledgeSection} from './knowledge-section.type'
import {PresentationSection} from './presentation-section.types'
import {PromotionalBannerSection} from './promotional-banner-section.types'
import {InspirationSection} from './inspiration-section.types'
import {PageMeta} from './seo.types'
import {Observable} from 'rxjs'
import {ContentSection} from './content-section.types'
import {SignupSection} from './signup-section.types'
import {ProMapSection} from './pro-map-section.types'
import {RelatedRegionSection} from './related-region-section.types'
import {RelatedIndustrySection} from './related-industry-section.types'
import {RelatedArticlesSection} from './related-articles-section.types'
import {VideoSection} from './video-section.types'

export interface Region {
  cmsId: string
  postalCodes: number[]
  regionName: string
  slug: string
  relatedRegions: RelatedRegion[]
  doNotIndex: boolean
}

export interface RelatedRegion {
  regionName: string
  slug: string
}

export interface RegionWithExcludedIndustries extends Region {
  excludedIndustryIds: number[]
}

export interface RegionalIndustry {
  cmsId: string
  id: number
  slug: string
  label: string
  textVariable?: string
  hideInGeneratedPages: boolean
}

export interface CraftsmenRegionPage {
  content: CraftsmenRegionPageContent[]
  cover: CraftsmenRegionPageCoverContent
  linkedIndustries: FeaturedIndustry[]
  seo?: PageMeta
}

export interface FeaturedIndustry {
  label: string
  slug: string
  hideInGeneratedPages: boolean
}

export interface IndustryRegionPage {
  content: IndustryRegionPageContent[]
  cover: IndustryRegionPageCoverContent
  seo?: PageMeta
}

export interface CraftsmenRegionPageCoverContent {
  title: string
  subtitle: string
}

export interface IndustryRegionPageCoverContent {
  title: string
  subtitle: string
}

export type CraftsmenRegionPageContent =
  | ReviewSection
  | SupportSection
  | {__type: 'ProDirectory'}
  | KnowledgeSection
  | PresentationSection
  | ContentSection
  | SignupSection
  | ProMapSection
  | RelatedRegionSection
  | VideoSection

export type IndustryRegionPageContent =
  | PresentationSection
  | ReviewSection
  | SupportSection
  | ContentSection
  | SignupSection
  | ProMapSection
  | {__type: 'ProDirectory'}
  | RelatedRegionSection
  | RelatedIndustrySection
  | RelatedArticlesSection
  | VideoSection

export function isRelatedArticlesSection(section: IndustryRegionPageContent): section is RelatedArticlesSection {
  return section.__type === 'RelatedArticlesSection'
}

export type CraftsmenRegionDirectoryPageContent =
  | PromotionalBannerSection
  | ReviewSection
  | KnowledgeSection
  | InspirationSection
  | ContentSection
  | SignupSection
  | VideoSection

export interface SideNavigationIndustryItem {
  slug: string
  title: string
}

export interface CraftsmenRegionDirectoryPage {
  topRegions$: Observable<Region[]>
  // Sidenav industries that link to the industry overview page
  sideNavigationIndustries$: Observable<SideNavigationIndustryItem[]>
  // Industries that will be showcased below the region in the industry-region directory
  industries$: Observable<RegionalIndustry[]>
  regions$: Observable<{total: number; value: RegionWithExcludedIndustries[]}>
  content$: Observable<CraftsmenRegionDirectoryPageContent[]>
}
